export default {
  //获取用户登录信息
  getuser: `/${PREFIX}/${PACKAGENAME}/loginsso/getuser`,
  questions: `/${PREFIX}/${PACKAGENAME}/callinterface/questions`,
  queryByGuideRule: `/${PREFIX}/${PACKAGENAME}/ybsl/queryByGuideRule`,
  queryQrcode: `/${PREFIX}/${PACKAGENAME}/ybsl/queryQrcode`,
  saveQrcode: `/${PREFIX}/${PACKAGENAME}/ybsl/saveQrcode`,
  annotation: `/${PREFIX}/${PACKAGENAME}/callinterface/annotation`,
  matters: `/${PREFIX}/${PACKAGENAME}/callinterface/matters`,
  getPoliceJiedao: `/${PREFIX}/${PACKAGENAME}/ybsl/getPoliceJiedao`,
  getCurXZQH: `/${PREFIX}/${PACKAGENAME}/callinterface/getCurXZQH`,
  checkYb: `/${PREFIX}/${PACKAGENAME}/ybsl/checkYb`,
  getSxForm: `/${PREFIX}/${PACKAGENAME}/ybsl/getSxForm`,
  uploadToTis: `/${PREFIX}/${PACKAGENAME}/ybsl/uploadToTis`,
  zz_download_other: `/${PREFIX}/${PACKAGENAME}/certificate/downloadother`,
  submitSx: `/${PREFIX}/${PACKAGENAME}/ybsl/submitSx`,
  deleteFileFromTis: `/${PREFIX}/${PACKAGENAME}/ybsl/deleteFileFromTis`,
  formPrint: `/${PREFIX}/${PACKAGENAME}/ybsl/formPrint`,
  judgeFile: `/${PREFIX}/${PACKAGENAME}/ybsl/judgeFile`,
  service: `/${PREFIX}/${PACKAGENAME}/callinterface/services`,
  unionprocess: `/${PREFIX}/${PACKAGENAME}/callinterface/unionprocess`,
};

export const devURL = PUBLICENV;
export const validateLoginURL = "http://zwdtuser.sh.gov.cn/uc/login/login.jsp?redirect_uri=";


// WEBPACK FOOTER //
// ./js/assets/js/urlMapper.js